export class OrderMetadata {
  constructor ({ purchaseOrderNumber, notes } = {}) {
    this.purchaseOrderNumber = purchaseOrderNumber || null
    this.notes = notes || null
  }
}
